/*export const din276_18 = {
  year: 2018,
  data: [
    {
      number: 100,
      label: "Grundstück",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 200,
      label: "Vorbereitende Maßnahmen",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 300,
      label: "Bauwerk - Baukonstruktionen",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 400,
      label: "Bauwerk - Technische Anlagen",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 500,
      label: "Außenanlagen und Freiflächen",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 600,
      label: "Ausstattung und Kunstwerke",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 700,
      label: "Baunebenkosten",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
    {
      number: 800,
      label: "Finanzierung",
      defaultPercent: "To be implemented",
      phases: "To be implemented",
    },
  ],
};*/

export const din276_18 = {
  year: 2018,
  data: [
    {
      number: '100',
      label: 'Grundstück',
      description:
        'Kosten der für das Bauprojekt vorgesehenen Fläche eines oder mehrerer im Grundbuch und im Liegenschaftskataster ausgewiesenen Grundstücke. Dazu gehören die mit dem Erwerb und dem Eigentum des Grundstücks verbundenen Nebenkosten sowie die Kosten für das Aufheben von Rechten und Belastungen.',

      phases: [
        {
          number: '110',
          label: 'Grundstückswert',
          description:
            'Als Kosten sind der Kaufpreis oder der Verkehrswert (Marktwert) des Grundstücks und ggf. auch grundstücksgleicher Rechte (z. B. bei Erbbaurecht) anzusetzen.',
        },
        {
          number: '120',
          label: 'Grundstücksnebenkosten',
          description:
            'Kosten, die im Zusammenhang mit dem Erwerb und dem Eigentum des Grundstücks entstehen',
          phases: [
            {
              number: '121',
              label: 'Vermessungsgebühren',
              description:
                'Gebühren für die Grenzvermessung (z. B. Abmarkung, Grenzfeststellung, Teilungsvermessung) sowie für die Vermessung zur Übernahme in das Liegenschaftskataster einschließlich der Verwaltungsgebühren Die Kosten der Ingenieurvermessung (z. B. Lageplan, Bauvermessung) gehören zur KG 745.',
            },

            {
              number: '122',
              label: 'Gerichtsgebühren',
              description:
                'Gebühren für die mit dem Grundstückserwerb verbundenen Eintragungen und Löschungen im Grundbuch',
            },
            {
              number: '123',
              label: 'Notargebühren',
              description:
                'Gebühren für die Aufstellung sowie die Abwicklung und den Vollzug des notariellen Kaufvertrags',
            },
            {
              number: '124',
              label: 'Grunderwerbsteuer',
              description:
                'Steuer für den Erwerb von unbebauten und bebauten Grundstücken sowie grundstücksgleichen Rechten',
            },
            {
              number: '125',
              label: 'Untersuchungen',
              description:
                'Untersuchungen zu Altlasten und zu deren Beseitigung, Baugrunduntersuchungen und Untersuchungen über die Bebaubarkeit, soweit sie zur Beurteilung des Grundstückswerts dienen',
            },
            {
              number: '126',
              label: 'Wertermittlungen',
              description:
                'Wertermittlungen von unbebauten und bebauten Grundstücken sowie grundstücksgleichen Rechten',
            },
            {
              number: '127',
              label: 'Genehmigungsgebühren',
              description:
                'Gebühren für amtliche Genehmigungen (z. B. von Grundstücksteilungen und Eintragungen in das Baulastenverzeichnis)',
            },
            {
              number: '128',
              label: 'Bodenordnung',
              description:
                'Kosten im Zusammenhang mit der Neuordnung und Umlegung von Grundstücken und Flurstücken sowie der Grenzregulierung (z. B. Ausgleichsleistungen, Umlegungsbeiträge)',
            },
            {
              number: '129',
              label: 'Sonstiges zur KG 120',
              description:
                'Sonstige Grundstücksnebenkosten (z. B. Maklerprovisionen, Beschaffung von Karten und Plänen)',
            },
          ],
        },
        {
          number: '130',
          label: 'Rechte Dritter',
          description:
            'Kosten für das Aufheben von Rechten Dritter, um möglichst frei über das Grundstück verfügen zu können',
          phases: [
            {
              number: '131',
              label: 'Abfindungen',
              description:
                'Abfindungen und Entschädigungen für bestehende Nutzungsrechte (z. B. Miet- und Pachtverträge)',
            },
            {
              number: '132',
              label: 'Ablösen dinglicher Rechte',
              description:
                'Ablösen von Lasten und Beschränkungen (z. B. Wegerechte, Grundpfandrechte, Baulasten)',
            },

            {
              number: '139',
              label: 'Sonstiges zur KG 130',
              description:
                'Sonstige Kosten und Gebühren (z. B. für Räumungsklagen)',
            },
          ],
        },
      ],
    },

    {
      number: '200',
      label: 'Vorbereitende Maßnahmen',
      description:
        'Vorbereitende Maßnahmen, um die Baumaßnahme auf dem Grundstück durchführen zu können',
      phases: [
        {
          number: '210',
          label: 'Herrichten',
          description: 'Herrichten des Grundstücks',
          phases: [
            {
              number: '211',
              label: 'Sicherungsmaßnahmen',
              description:
                'Schutz von vorhandenen Baukonstruktionen und technischen Anlagen sowie Sichern von Bewuchs und Vegetationsschichten',
            },
            {
              number: '212',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbrechen, Beseitigen und Entsorgen von vorhandenen Baukonstruktionen, technischen Anlagen, Außenanlagen und Freiflächen zum Herrichten des Grundstücks',
            },
            {
              number: '213',
              label: 'Altlastenbeseitigung',
              description:
                'Beseitigen von gefährlichen Stoffen, Sanieren belasteter und kontaminierter Böden',
            },
            {
              number: '214',
              label: 'Herrichten der Geländeoberfläche',
              description:
                'Roden von Bewuchs, Planieren, Bodenbewegungen einschließlich Oberbodensicherung, soweit nicht in der KG 500 erfasst',
            },
            {
              number: '215',
              label: 'Kampfmittelräumung',
              description:
                'Maßnahmen zum Auffinden und zur Räumung von Kampfmitteln',
            },
            {
              number: '216',
              label: 'Kulturhistorische Funde',
              description: 'Sicherung von kulturhistorischen Funden',
            },
            {
              number: '219',
              label: 'Sonstiges zur KG 210',
              description: 'Evakuierungskosten im Zuge von Kampfmittelräumung',
            },
          ],
        },

        {
          number: '220',
          label: 'Öffentliche Erschließung',
          description:
            'Anteilige Kosten aufgrund gesetzlicher Vorschriften (Erschließungsbeiträge/Anliegerbeiträge) und Kosten aufgrund öffentlich-rechtlicher Verträge für - die Beschaffung oder den Erwerb der Erschließungsflächen gegen Entgelt durch den Träger der öffentlichen Erschließung, - die Herstellung oder Änderung gemeinschaftlich genutzter technischer Anlagen (z. B. zur Ableitung von Abwasser sowie zur Versorgung mit Wasser, Wärme, Gas, Strom und Telekommunikation), - die erstmalige Herstellung oder den Ausbau der öffentlichen Verkehrsflächen, der Grünflächen und sonstiger Freiflächen für öffentliche Nutzung. Kostenzuschüsse und Anschlusskosten sollten getrennt ausgewiesen werden. Beim Erwerb eines bereits erschlossenen Grundstücks kann der Wert der vor dem Erwerb aufgewendeten Erschließungskosten in der KG 110 erfasst werden.',
          phases: [
            {
              number: '221',
              label: 'Abwasserentsorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '222',
              label: 'Wasserversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '223',
              label: 'Gasversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '224',
              label: 'Fernwärmeversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },

            {
              number: '225',
              label: 'Stromversorgung',
              description: 'Kostenzuschüsse, Anschlusskosten',
            },
            {
              number: '226',
              label: 'Telekommunikation',
              description:
                'Einmalige Entgelte für die Bereitstellung und Änderung von Netzanschlüssen',
            },
            {
              number: '227',
              label: 'Verkehrserschließung',
              description:
                'Erschließungsbeiträge für die Verkehrs- und Freianlagen einschließlich deren Entwässerung und Beleuchtung',
            },
            {
              number: '228',
              label: 'Abfallentsorgung',
              description:
                'Kostenzuschüsse, Anschlusskosten (z. B. für eine leitungsgebundene Abfallentsorgung)',
            },
            {
              number: '229',
              label: 'Sonstiges zur KG 220',
              description: '',
            },
          ],
        },

        {
          number: '230',
          label: 'Nichtöffentliche Erschließung',
          description:
            'Verkehrsflächen und technische Anlagen, die ohne öffentlich-rechtliche Verpflichtung oder Beauftragung mit dem Ziel der späteren Übertragung in den Gebrauch der Allgemeinheit hergestellt und ergänzt werden Kosten von Anlagen auf dem eigenen Grundstück gehören zur KG 500. Soweit erforderlich, kann die KG 230 entsprechend der KG 220 untergliedert werden.',
        },
        {
          number: '240',
          label: 'Ausgleichsmaßnahmen und -abgaben',
          description:
            'Maßnahmen und Abgaben, die aufgrund öffentlich-rechtlicher Bestimmungen aus Anlass des geplanten Bauvorhabens einmalig und zusätzlich zu den Erschließungsbeiträgen entstehen',
          phases: [
            {
              number: '241',
              label: 'Ausgleichsmaßnahmen',
              description:
                'Umsetzen von Verpflichtungen (z. B. Artenschutz, Naturschutz, Stellplätze, Baumbestand); Ausgleichsmaßnahmen auf dem eigenen Grundstück sind bei den betreffenden Kostengruppen zu erfassen.',
            },
            {
              number: '242',
              label: 'Ausgleichsabgaben',
              description:
                'Ablösen von Verpflichtungen (z. B. Artenschutz, Naturschutz, Stellplätze, Baumbestand)',
            },
            { number: '249', label: 'Sonstiges zur KG 240', description: '' },
          ],
        },
        {
          number: '250',
          label: 'Übergangsmaßnahmen',
          description:
            'Provisorische Maßnahmen baulicher und organisatorischer Art, insbesondere bei Bauprojekten im Bestand, mit denen während der Projektdauer die Nutzung und der Betrieb aufrecht erhalten werden können',
          phases: [
            {
              number: '251',
              label: 'Bauliche Maßnahmen',
              description:
                'Erstellung, Anpassung oder Umlegung von Bauwerken, Außenanlagen und Freiflächen als provisorische Maßnahme der endgültigen Bauwerke, Außenanlagen und Freiflächen einschließlich des Wiederentfernens der Provisorien , soweit nicht in anderen Kostengruppen erfasst (z. B. Errichtung von Behelfsbauwerken)',
            },
            {
              number: '252',
              label: 'Organisatorische Maßnahmen',
              description:
                'Auslagerung von Nutzungen während der Bauzeit (z. B. Kosten für Umzug und Miete)',
            },
            {
              number: '259',
              label: 'Sonstiges zur KG 250',
              description:
                'Betriebskosten nach DIN 18960 von provisorischen Maßnahmen',
            },
          ],
        },
        ,
      ],
    },

    {
      number: '300',
      label: 'Bauwerk - Baukonstruktionen',
      description:
        'Bauleistungen und Lieferungen zur Herstellung des Bauwerks von Hochbauten, Ingenieurbauten und Infrastrukturanlagen, jedoch ohne die technischen Anlagen (KG 400). Dazu gehören auch die mit dem Bauwerk fest verbundenen Einbauten, die der jeweiligen Zweckbestimmung dienen, sowie die mit den Baukonstruktionen in Zusammenhang stehenden übergreifenden Maßnahmen. Zu den Baukonstruktionen gehören auch die mit dem Bauwerk verbundenen Dach-, Fassaden- und Innenraumbegrünungen. Außenanlagen außerhalb des Bauwerks und gestaltete Freiflächen gehören zur KG 500. Bei Umbauten und Modernisierungen von Baukonstruktionen zählen hierzu auch die Kosten von Teilabbruch-, Instandsetzungs-, Sicherungs- und Demontagearbeiten. Die Kosten sind bei den betreffenden Kostengruppen auszuweisen.',
      phases: [
        {
          number: '310',
          label: 'Baugrube/Erdbau',
          description:
            'Oberbodenarbeiten und Bodenarbeiten, Erdbaumaßnahmen, Baugruben, Dämme, Einschnitte, Wälle, Hangsicherungen',
          phases: [
            {
              number: '311',
              label: 'Herstellung',
              description:
                'Bodenabtrag, Bodensicherung und Bodenauftrag; Aushub von Baugruben und Baugräben einschließlich der Arbeitsräume und Böschungen; Lagern, Bodenlieferung und Bodenabfuhr; Verfüllungen und Hinterfüllungen; Planum, Mulden, Bankette',
            },
            {
              number: '312',
              label: 'Umschließung',
              description:
                'Verbau und Sicherung von Baugruben Baugräben, Dämmen, Wällen und Einschnitten (z. B. Schlitz-, Pfahl-, Spund-, Trägerbohl-, Injektions- und Spritzbetonsicherung) einschließlich der Verankerungen, Absteifungen und Böschungen',
            },
            {
              number: '313',
              label: 'Wasserhaltung',
              description:
                'Beseitigung des Grund- und Schichtenwassers während der Bauzeit',
            },
            {
              number: '314',
              label: 'Vortrieb',
              description:
                'Erdausbruch unter Tage einschließlich Stützung und Sicherung',
            },
            {
              number: '319',
              label: 'Sonstiges zur KG 310',
              description: '',
            },
          ],
        },
        {
          number: '320',
          label: 'Gründung, Unterbau',
          description:
            'Gründungs- und Unterbaumaßnahmen für das Bauwerk einschließlich der zugehörigen Erdarbeiten und Sauberkeitsschichten, soweit nicht in der KG 310 erfasst',
          phases: [
            {
              number: '321',
              label: 'Baugrundverbesserung',
              description:
                'Bodenaustausch, Verdichtung, Einpressung, Ankerung, Stützmaßnahmen; Bodenlockerung und Verlegung von Geotextilien',
            },
            {
              number: '322',
              label: 'Flachgründungen und Bodenplatten',
              description:
                'Einzelfundamente, Streifenfundamente, Fundament-, Sohl- und Bodenplatten',
            },
            {
              number: '323',
              label: 'Tiefgründungen',
              description:
                'Pfahlgründung einschließlich der Roste; Brunnengründungen; Verankerungen',
            },
            {
              number: '324',
              label: 'Gründungsbeläge',
              description:
                'Beläge auf Sohl-, Boden- und Fundamentplatten (z. B. Estriche, Dichtungs-, Dämm-, Schutz- und Nutzschichten)',
            },

            {
              number: '325',
              label: 'Abdichtungen und Bekleidungen',
              description:
                'Konstruktionsschichten unterhalb der Sohl-, Boden- und Fundamentplatte, Abdichtungen und Bekleidungen der Gründung einschließlich Dämmungen sowie Filter-, Trenn-, Sauberkeits- und Schutzschichten',
            },
            {
              number: '326',
              label: 'Dränagen',
              description:
                'Leitungen, Schächte, Packungen, Pumpensümpfe, Tiefenentwässerung, Oberflächenentwässerung',
            },
            { number: '329', label: 'Sonstiges zur KG 320', description: '' },
          ],
        },
        {
          number: '330',
          label: 'Außenwände/Vertikale Baukonstruktionen, außen',
          description:
            'Tragende und nichttragende vertikale Baukonstruktionen, die sich an den Außenseiten des Bauwerks befinden, d. h. insbesondere dem Außenklima ausgesetzt sind bzw. an das Erdreich oder an andere Bauwerke grenzen. Die KG 331 und die KG 332 können ggf. als KG 331 zusammengefasst werden.',
          phases: [
            {
              number: '331',
              label: 'Tragende Außenwände',
              description:
                'Außenwände und flächige Konstruktionen, die für die Standfestigkeit des Bauwerks erforderlich sind, einschließlich horizontaler Abdichtungen sowie Schlitzen und Durchführungen',
            },
            {
              number: '332',
              label: 'Nichttragende Außenwände',
              description:
                'Außenwände und flächige Konstruktionen, die für die Standfestigkeit des Bauwerks nicht erforderlich sind (z. B. Brüstungen, Attiken, Ausfachungen) einschließlich horizontaler Abdichtungen sowie Schlitzen, Durchführungen und füllender Teile (z. B. Dämmungen)',
            },
            {
              number: '333',
              label: 'Außenstützen',
              description:
                'Stützen, Säulen, Pylone und Pfeiler an den Außenseiten des Bauwerks mit einem Querschnittsverhältnis < 1 : 4',
            },
            {
              number: '334',
              label: 'Außenwandöffnungen',
              description:
                'Türen, Tore, Fenster, Schaufenster, Glasfassaden und sonstige Öffnungen einschließlich Fensterbänken, Umrahmungen, Beschlägen, Antrieben, Lüftungselementen und sonstiger Einbauteile',
            },
            {
              number: '335',
              label: 'Außenwandbekleidungen, außen',
              description:
                'Äußere Bekleidungen an Wänden und Stützen einschließlich Putz-, Dichtungs-, Dämm- und Schutzschichten Dazu gehören auch auf der Außenseite fest mit den Außenwänden verbundene Fassaden- und Wandbegrünungssysteme einschließlich aller Teile (z. B. Gefäße, Substrate, Pflanzen, Fertigstellungs- und Entwicklungspflege, Dünge- und Bewässerungsvorrichtungen).',
            },
            {
              number: '336',
              label: 'Außenwandbekleidungen, innen',
              description:
                'Innere Bekleidungen an Wänden und Stützen einschließlich Putz-, Dichtungs-, Dämm- und Schutzschichten Dazu gehören auch auf der Innenseite fest mit den Außenwänden verbundene Wandbegrünungssysteme einschließlich aller Teile.',
            },
            {
              number: '337',
              label: 'Elementierte Außenwandkonstruktionen',
              description:
                'Vorgefertigte Wände und vertikale Baukonstruktionen, die neben ihrer Kernkonstruktion auch Türen und Fenster oder äußere und innere Bekleidungen enthalten können',
            },
            {
              number: '338',
              label: 'Lichtschutz zur KG 330',
              description:
                'Konstruktionen für Sonnen-, Sicht- und Blendschutz, Verdunkelung (z. B. Rollläden, Markisen und Jalousien) einschließlich Antrieben wie Rohrmotoren oder Gurtwicklern',
            },
            {
              number: '339',
              label: 'Sonstiges zur KG 330',
              description: 'Gitter, Stoßabweiser, Handläufe, Berührungsschutz',
            },
          ],
        },
        {
          number: '340',
          label: 'Innenwände/Vertikale Baukonstruktionen, innen',
          description:
            'Tragende und nichttragende vertikale Baukonstruktionen, die sich innerhalb des Bauwerks befinden. Die KG 341 und die KG 342 können ggf. als KG 341 zusammengefasst werden.',
          phases: [
            {
              number: '341',
              label: 'Tragende Innenwände',
              description:
                'Tragende Innenwände und flächige Konstruktionen, die für die Standfestigkeit des Bauwerks erforderlich sind, einschließlich horizontaler Abdichtungen sowie Schlitzen und Durchführungen',
            },

            {
              number: '342',
              label: 'Nichttragende Innenwände',
              description:
                'Nichttragende Innenwände und flächige Konstruktionen, die für die Standfestigkeit des Bauwerks nicht erforderlich sind (z. B. Brüstungen, Ausfachungen) einschließlich horizontaler Abdichtungen sowie Schlitzen, Durchführungen und füllender Teile (z. B. Dämmungen)',
            },
            {
              number: '343',
              label: 'Innenstützen',
              description:
                'Stützen, Säulen, Pylone und Pfeiler innerhalb des Bauwerks mit einem Querschnittsverhältnis < 1 : 4',
            },
            {
              number: '344',
              label: 'Innenwandöffnungen',
              description:
                'Innenliegende Fenster, Schaufenster, Türen, Tore und sonstige Öffnungen einschließlich Fensterbänken, Umrahmungen, Beschlägen, Antrieben, Lüftungselementen und sonstiger Einbauteile',
            },
            {
              number: '345',
              label: 'Innenwandbekleidungen',
              description:
                'Bekleidungen an Wänden und Stützen einschließlich Putz-, Dichtungs-, Dämm- und Schutzschichten; dazu gehören auch fest mit den Innenwänden verbundene Begrünungssysteme einschließlich Fertigstellungs- und Entwicklungspflege',
            },
            {
              number: '346',
              label: 'Elementierte Innenwandkonstruktionen',
              description:
                'Vorgefertigte Wände und vertikale Baukonstruktionen, die neben ihrer Kernkonstruktion auch Türen und Fenster oder Innenwandbekleidungen enthalten können; Falt- und Schiebewände, Sanitärtrennwände, Verschläge',
            },
            {
              number: '347',
              label: 'Lichtschutz zur KG 340',
              description:
                'Konstruktionen für Sonnen-, Sicht- und Blendschutz, Verdunkelung (z. B. Rollläden, Markisen und Jalousien) einschließlich Antrieben wie Rohrmotoren oder Gurtwicklern',
            },
            {
              number: '349',
              label: 'Sonstiges zur KG 340',
              description: 'Gitter, Stoßabweiser, Handläufe, Berührungsschutz',
            },
          ],
        },

        {
          number: '350',
          label: 'Decken/Horizontale Baukonstruktionen',
          description:
            'Tragende und nichttragende Baukonstruktionen für Decken, Treppen, Rampen und andere horizontale Baukonstruktionen',
          phases: [
            {
              number: '351',
              label: 'Deckenkonstruktionen',
              description:
                'Tragende Konstruktionen für Decken, Treppen, Rampen, Balkone und andere horizontale Baukonstruktionen einschließlich Über- und Unterzügen, Abstützungen und füllender Teile (z. B. Dämmungen, Hohlkörper, Blindböden, Schüttungen)',
            },
            {
              number: '352',
              label: 'Deckenöffnungen',
              description:
                'Horizontale Verglasungen, Luken, einschließlich Umrahmungen, Beschlägen und sonstiger Einbauteile',
            },
            {
              number: '353',
              label: 'Deckenbeläge',
              description:
                'Beläge auf Deckenkonstruktionen einschließlich Estrichen, Dichtungs-, Dämm-, Schutz- und Nutzschichten sowie Schwingböden und Installationsdoppelböden Dazu gehören auch fest mit den Decken verbundene Begrünungssysteme einschließlich Fertigstellungs- und Entwicklungspflege.',
            },
            {
              number: '354',
              label: 'Deckenbekleidungen',
              description:
                'Bekleidungen unter Deckenkonstruktionen einschließlich Putz-, Dichtungs-, Dämm- und Schutzschichten; Licht- und Kombinationsdecken',
            },
            {
              number: '355',
              label: 'Elementierte Deckenkonstruktionen',
              description:
                'Vorgefertigte Decken, Treppen, Rampen und andere horizontale Baukonstruktionen, die neben ihrer Kernkonstruktion auch Öffnungen, Beläge oder Bekleidungen enthalten können',
            },
            {
              number: '359',
              label: 'Sonstiges zur KG 350',
              description:
                'Gitter, Geländer, Stoßabweiser, Handläufe, Abdeckungen, Schachtdeckel, Roste, Leitern, Berührungsschutz',
            },
          ],
        },

        {
          number: '360',
          label: 'Dächer',
          description:
            'Tragende und nichttragende Baukonstruktionen für flache und geneigte Dächer und andere horizontale Baukonstruktionen, die das Bauwerk nach oben abschließen',
          phases: [
            {
              number: '361',
              label: 'Dachkonstruktionen',
              description:
                'Tragende Konstruktionen von Dächern, Vordächern, Dachstühlen, Raumtragwerken, Kuppeln und Gewölben einschließlich Über- und Unterzügen, Abstützungen und füllender Teile (z. B. Dämmungen, Hohlkörper, Blindböden, Schüttungen)',
            },
            {
              number: '362',
              label: 'Dachöffnungen',
              description:
                'Dachfenster, Ausstiege und andere Dachöffnungen einschließlich Umrahmungen, Beschlägen, Antrieben, Lüftungselementen und sonstiger Einbauteile; natürliche Rauch- und Wärmeabzugsanlagen',
            },
            {
              number: '363',
              label: 'Dachbeläge',
              description:
                'Beläge auf Dachkonstruktionen von ungenutzten und genutzten Dachflächen einschließlich Schalungen, Lattungen, Gefälle-, Dichtungs-, Dämm-, Drän-, Schutz- und Nutzschichten sowie die Entwässerung der Dachflächen bis zum Anschluss an die Abwasseranlagen (einschließlich der in Klempnerarbeit hergestellten Rinnen und Fallrohre) Dazu gehören auch extensive und intensive Dachbegrünungen einschließlich aller Teile (z. B. Substrate, Pflanzen, Fertigstellungs- und Entwicklungspflege, Dünge- und Bewässerungsvorrichtungen).',
            },
            {
              number: '364',
              label: 'Dachbekleidungen',
              description:
                'Bekleidungen unter Dachkonstruktionen einschließlich Putz-, Dichtungs-, Dämm- und Schutzschichten; Licht- und Kombinationsdecken',
            },
            {
              number: '365',
              label: 'Elementierte Dachkonstruktionen',
              description:
                'Vorgefertigte Dächer, die neben ihrer Kernkonstruktion auch Öffnungen, Beläge oder Bekleidungen enthalten können',
            },
            {
              number: '366',
              label: 'Lichtschutz zur KG 360',
              description:
                'Konstruktionen für Sonnen-, Sicht-, und Blendschutz, Verdunkelung (z. B. Rollläden, Markisen und Jalousien) einschließlich Antrieben wie Rohrmotoren oder Gurtwicklern',
            },
            {
              number: '369',
              label: 'Sonstiges zur KG 360',
              description:
                'Gitter, Geländer, Handläufe, Laufbohlen, Schneefänge, Dachleitern',
            },
          ],
        },
        {
          number: '370 ',
          label: 'Infrastrukturanlagen',
          description:
            'Eigenständige Bauwerke von Infrastrukturanlagen für Verkehr sowie Ver- und Entsorgung, soweit die Kosten nicht in den KG 330 bis 360 erfasst werden können Die Erdbaumaßnahmen für diese Anlagen gehören zur KG 310, die Gründungs- und Unterbaumaßnahmen zur KG 320. Die verfahrenstechnischen Anlagen gehören zu den KG 477 und 478.',
          phases: [
            {
              number: '371',
              label: 'Anlagen für den Straßenverkehr',
              description:
                'Oberbau von Flächen für den Fuß- und Radverkehr, für den Leicht- und Schwerverkehr und für den ruhenden Verkehr (Wege, Straßen und Plätze)',
            },
            {
              number: '372',
              label: 'Anlagen für den Schienenverkehr',
              description:
                'Oberbau von Gleisanlagen (Gleise, Weichen und Gleisabschlüsse) sowie von Bahnsteiganlagen',
            },
            {
              number: '373',
              label: 'Anlagen für den Flugverkehr',
              description: 'Oberbau- und Deckschichten von Flugverkehrsflächen',
            },
            {
              number: '374',
              label: 'Anlagen des Wasserbaus',
              description:
                'Baukonstruktionen von Anlagen des Verkehrswasserbaus (z. B. Kanäle, Schleusen, Hafen-, Dock- und Werftanlagen) sowie des Gewässerausbaus (z. B. Uferbefestigungen, Dämme, Deiche, Durchlässe, Wehre)',
            },
            {
              number: '375',
              label: 'Anlagen der Abwasserentsorgung',
              description:
                'Baukonstruktionen von Anlagen der Regenrückhaltung, der Abwasser- und Schlammbehandlung sowie von Abwasserleitungsnetzen',
            },

            {
              number: '376',
              label: 'Anlagen der Wasserversorgung',
              description:
                'Baukonstruktionen von Anlagen der Wassergewinnung, Wasserspeicherung, Wasseraufbereitung und Wasserverteilung',
            },
            {
              number: '377',
              label: 'Anlagen der Energie- und Informationsversorgung',
              description:
                'Baukonstruktionen von Versorgungsanlagen für elektrische Energieträger, thermische Energieträger (Wärme- und Kälteversorgung) sowie für Information (z. B. Erzeugungs- und Verteilungsanlagen, Rohrleitungs- und Kabelleitungsanlagen einschließlich Masten und Rohrbrücken)',
            },
            {
              number: '378',
              label: 'Anlagen der Abfallentsorgung',
              description:
                'Baukonstruktionen von Anlagen zur Sammlung, Lagerung, Deponierung, Aufbereitung von Abfällen und Wertstoffen',
            },
            {
              number: '379',
              label: 'Sonstiges zur KG 370',
              description:
                'Ver- und Entsorgungsanlagen für Gase, Flüssigkeiten und Feststoffe, Transportanlagen wie Förderbandanlagen',
            },
          ],
        },
        {
          number: '380',
          label: 'Baukonstruktive Einbauten',
          description:
            'Mit dem Bauwerk fest verbundene Einbauten, jedoch ohne die nutzungsspezifischen Anlagen (siehe KG 470) Für die Abgrenzung gegenüber der KG 600 ist maßgebend, dass die Einbauten durch ihre Beschaffenheit und die Art ihres Einbaus technische und planerische Maßnahmen erforderlich machen (z. B. Anfertigen von Ausführungszeichnungen, statischen und anderen Berechnungen, Anschließen von Installationen).',
          phases: [
            {
              number: '381',
              label: 'Allgemeine Einbauten',
              description:
                'Einbauten (insbesondere in Hochbauten), die einer allgemeinen Zweckbestimmung dienen (z. B. Einbaumöbel wie Sitz- und Liege- möbel, Gestühl, Podien, Tische, Theken, Schränke, Garderoben, Regale, Einbauküchen)',
            },
            {
              number: '382',
              label: 'Besondere Einbauten',
              description:
                'Einbauten (insbesondere in Hochbauten), die einer besonderen Zweckbestimmung des Bauwerks dienen (z. B. Werkbänke in Werkhallen, Altäre in Kirchen, Einbausportgeräte in Sporthallen, Gleisanlagen in Bahnhöfen)',
            },
            {
              number: '383',
              label: 'Landschaftsgestalterische Einbauten',
              description:
                'Einbauten beispielsweise in Biosphärenhallen, zoologischen Anlagen, Einkaufszentren, einschließlich Einfassungen, Aufkantungen, Substraten, Pflanzen, Fertigstellungs- und Entwicklungspflege, Vorrichtungen zum Düngen sowie zur Be- und Entwässerung (soweit nicht in anderen Kostengruppen erfasst)',
            },
            {
              number: '384',
              label: 'Mechanische Einbauten',
              description:
                'Mechanische Einbauten (insbesondere in Ingenieurbauten), die einer besonderen Zweckbestimmung des Bauwerks in der Wasserversorgung (z. B. Räumer für Absetzbecken), in der Abwasserentsorgung (z. B. Räumer für Absetzbecken, Kammerfilterpressen, Oberflächenbelüfter, Gasentschwefler, Gasspeicher), in der Abfallentsorgung (z. B. Schredder, Müllpressen) und im Wasserbau (z. B. Stahlbaukonstruktionen bei Schleusen und Wehren, Grob- und Feinrechen) dienen Zu den mechanischen Einbauten gehören die Antriebe der Einbauten, soweit nicht in der KG 466 erfasst. Die Anschlusstechnik und die Verfahrenstechnik sind in der KG 400 erfasst.',
            },
            {
              number: '385',
              label: 'Einbauten in Konstruktionen des Ingenieurbaus',
              description:
                'Abdichtungen und Dränagen in Stauanlagen, Dämmen und Deponien, soweit nicht in den KG 310 bis 360 erfasst',
            },
            {
              number: '386',
              label: 'Orientierungs- und Informationssysteme',
              description:
                'Einbausysteme, die der Orientierung und Information dienen (z. B. für Flucht, Rettung, Orientierung, Werbung)',
            },
            {
              number: '387',
              label: 'Schutzeinbauten',
              description: 'Rauchschutzvorhänge',
            },
            {
              number: '389',
              label: 'Sonstiges zur KG 380',
              description: 'Sanitärzellen (baukonstruktiver Anteil)',
            },
          ],
        },
        {
          number: '390',
          label: 'Sonstige Maßnahmen für Baukonstruktionen',
          description:
            'Baukonstruktionen und übergreifende Maßnahmen im Zusammenhang mit den Baukonstruktionen, die nicht einzelnen Kostengruppen der KG 300 zugeordnet werden können oder die nicht in der KG 490 oder der KG 590 erfasst sind',
          phases: [
            {
              number: '391',
              label: 'Baustelleneinrichtung',
              description:
                'Einrichten, Vorhalten, Betreiben und Räumen der übergeordneten Baustelleneinrichtung (z. B. Material- und Geräteschuppen, Lager-, Wasch-, Toiletten- und Aufenthaltsräume, Bauwagen, Misch- und Transportanlagen, Energie- und Bauwasseranschlüsse, Baustraßen, Lager- und Arbeitsplätze, Verkehrssicherungen, Abdeckungen, Bauschilder, Bau- und Schutzzäune, Baubeleuchtung, Baustrom, Bauwasser)',
            },
            {
              number: '392',
              label: 'Gerüste',
              description:
                'Auf-, Um-, und Abbauen sowie Vorhalten von Gerüsten',
            },
            {
              number: '393',
              label: 'Sicherungsmaßnahmen',
              description:
                'Sicherungsmaßnahmen an bestehenden Bauwerken (z. B. Unterfangungen, Abstützungen)',
            },
            {
              number: '394',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbruch- und Demontagearbeiten einschließlich Zwischenlagern wiederverwendbarer Teile, Abfuhr des Abbruchmaterials, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '395',
              label: 'Instandsetzungen',
              description:
                'Maßnahmen zur Wiederherstellung des zum bestimmungsgemäßen Gebrauch geeigneten Zustandes, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '396',
              label: 'Materialentsorgung',
              description:
                'Entsorgung von Materialien und Stoffen, die bei dem Abbruch, bei der Demontage und bei dem Ausbau von Bauteilen oder bei der Erstellung einer Bauleistung anfallen zum Zweck des Recyclings oder der Deponierung',
            },
            {
              number: '397',
              label: 'Zusätzliche Maßnahmen',
              description:
                'Zusätzliche Maßnahmen bei der Erstellung von Baukonstruktionen (z. B. Schutz von Personen und Sachen sowie betriebliche Sicherungsmaßnahmen beim Bauen unter Betrieb); Reinigung vor Inbetriebnahme; Maßnahmen aufgrund von Forderungen des Wasser-, Landschafts-, Lärm- und Erschütterungsschutzes während der Bauzeit; Schlechtwetter und Winterbauschutz, Erwärmung des Bauwerks, Schneeräumung',
            },
            {
              number: '398',
              label: 'Provisorische Baukonstruktionen',
              description:
                'Erstellung, Betrieb und Beseitigung provisorischer Baukonstruktionen, Anpassung des Bauwerks bis zur Inbetriebnahme des endgültigen Bauwerks',
            },

            {
              number: '399',
              label: 'Sonstiges zur KG 390',
              description:
                'Baukonstruktionen und Maßnahmen, die mehrere Kostengruppen betreffen (z. B. Schließanlagen, Schächte, Schornsteine, soweit nicht in anderen Kostengruppen erfasst); Baustellengemeinkosten',
            },
          ],
        },
      ],
    },

    {
      number: '400',
      label: 'Bauwerk - Technische Anlagen',
      description:
        'Bauleistungen und Lieferungen zur Herstellung der technischen Anlagen des Bauwerks von Hochbauten, Ingenieurbauten und Infrastrukturanlagen Dazu gehören auch die übergreifenden Maßnahmen im Zusammenhang mit den technischen Anlagen. Die einzelnen technischen Anlagen enthalten die zugehörigen Gestelle, Befestigungen, Armaturen, Wärme- und Kältedämmung, Schallund Brandschutzvorkehrungen, Abdeckungen, Verkleidungen, Anstriche, Kennzeichnungen sowie die werkseitig integrierten Mess-, Steuer- und Regelanlagen. Dazu gehören auch die Betriebskosten bis zur Abnahme. Die Kosten für das Erstellen und Schließen von Schlitzen und Durchführungen sowie von Rohr- und Kabelgräben werden in der Regel in der KG 300 erfasst. Zu den technischen Anlagen zählen bei Umbauten und Modernisierungen auch die Kosten von Teilabbruch-, Instandsetzungs-, Sicherungs- und Demontagearbeiten. Die Kosten sind bei den betreffenden Kostengruppen auszuweisen.',
      phases: [
        {
          number: '410',
          label: 'Abwasser-, Wasser-, Gasanlagen',
          description:
            'Zu den Abwasser-, Wasser- und Gasanlagen gehören im Wesentlichen die sanitärtechnischen Anlagen',
          phases: [
            {
              number: '411',
              label: 'Abwasseranlagen',
              description:
                'Abläufe, Abwasserleitungen, Abwassersammelanlagen, Abwasserbehandlungsanlagen, Hebeanlagen',
            },
            {
              number: '412',
              label: 'Wasseranlagen',
              description:
                'Wassergewinnungs-, Aufbereitungs- und Druckerhöhungsanlagen, Rohrleitungen, dezentrale Wassererwärmer, Sanitärobjekte',
            },
            {
              number: '413',
              label: 'Gasanlagen',
              description:
                'Gasanlagen für Wirtschaftswärme (Gaslagerungs- und –erzeugungsanlagen, Übergabestationen, Druckregelanlagen und Gasleitungen), soweit nicht in der KG 420 oder KG 470 erfasst',
            },
            {
              number: '419',
              label: 'Sonstiges zur KG 410',
              description:
                'Installationsblöcke, Sanitärzellen (technischer Anteil)',
            },
          ],
        },
        {
          number: '420',
          label: 'Wärmeversorgungsanlagen',
          description: '',
          phases: [
            {
              number: '421',
              label: 'Wärmeerzeugungsanlagen',
              description:
                'Brennstoffversorgung, Wärmeübergabestationen, Wärmeerzeugung auf der Grundlage von Brennstoffen oder unerschöpflichen Energiequellen einschließlich Schornsteinanschlüssen und zentraler Wassererwärmungsanlagen',
            },
            {
              number: '422',
              label: 'Wärmeverteilnetze',
              description:
                'Pumpen, Verteiler; Rohrleitungen für Raumheizflächen, raumlufttechnische Anlagen und sonstige Wärmeverbraucher',
            },
            {
              number: '423',
              label: 'Raumheizflächen',
              description: 'Heizkörper, Flächenheizsysteme',
            },
            {
              number: '424',
              label: 'Verkehrsheizflächen',
              description:
                'Fahrbahnbeheizung, Weichenheizung, Flugfeldbeheizung',
            },
            {
              number: '429',
              label: 'Sonstiges zur KG 420',
              description:
                'Schornsteine, soweit nicht in anderen Kostengruppen erfasst',
            },
          ],
        },
        {
          number: '430',
          label: 'Raumlufttechnische Anlagen',
          description: 'Anlagen mit und ohne Lüftungsfunktion',
          phases: [
            {
              number: '431',
              label: 'Lüftungsanlagen',
              description:
                'Abluftanlagen, Zuluftanlagen, Zu- und Abluftanlagen ohne oder mit einer thermodynamischen Luftbehandlungsfunktion, maschinelle Rauch- und Wärmeabzugsanlagen, Einzelraumlüfter, Einrohrlüfter',
            },
            {
              number: '432',
              label: 'Teilklimaanlagen',
              description:
                'Anlagen mit zwei oder drei thermodynamischen Luftbehandlungsfunktionen',
            },
            {
              number: '433',
              label: 'Klimaanlagen',
              description:
                'Anlagen mit vier thermodynamischen Luftbehandlungsfunktionen',
            },
            {
              number: '434',
              label: 'Kälteanlagen',
              description:
                'Kälteanlagen zur Raumkühlung und für lufttechnische Anlagen: Kälteerzeugungs- und Rückkühlanlagen einschließlich Pumpen, Verteilern und Rohrleitungen',
            },
            {
              number: '439',
              label: 'Sonstiges zur KG 430',
              description:
                'Lüftungsdecken, Kühldecken, Abluftfenster; Installationsdoppelböden, soweit nicht in anderen Kostengruppen erfasst',
            },
          ],
        },
        {
          number: '440',
          label: 'Elektrische Anlagen',
          description:
            'Elektrische Anlagen für Starkstrom einschließlich der Brandschutzdurchführungen, soweit nicht in anderen Kostengruppen erfasst, jedoch ohne die Anlagen der KG 450',
          phases: [
            {
              number: '441',
              label: 'Hoch- und Mittelspannungsanlagen',
              description: 'Schaltanlagen, Transformatoren',
            },
            {
              number: '442',
              label: 'Eigenstromversorgungsanlagen',
              description:
                'Stromerzeugungsaggregate einschließlich Kühlung, Abgasanlagen, Brennstoffversorgung, zentraler Batterie- und unterbrechungsfreier Stromversorgungsanlagen sowie photovoltaischer Anlagen',
            },
            {
              number: '443',
              label: 'Niederspannungsschaltanlagen',
              description:
                'Niederspannungshauptverteiler, Blindstromkompensationsanlagen, Maximumüberwachungsanlagen, Oberschwingungsfilter',
            },
            {
              number: '444',
              label: 'Niederspannungsinstallationsanlagen',
              description:
                'Kabel, Leitungen, Unterverteiler, Verlegesysteme, Installationsgeräte',
            },
            {
              number: '445',
              label: 'Beleuchtungsanlagen',
              description:
                'Ortsfeste Leuchten, Sicherheitsbeleuchtung und Beleuchtungsanlagen für Anlagen des Verkehrs sowie Flutlichtanlagen',
            },
            {
              number: '446',
              label: 'Blitzschutz- und Erdungsanlagen',
              description:
                'Auffangeinrichtungen, Ableitungen, Erdungen, Potentialausgleich',
            },
            {
              number: '447',
              label: 'Fahrleitungssysteme',
              description:
                'Stromführende Leitungen für den Schienen- und Straßenverkehr',
            },
            {
              number: '449',
              label: 'Sonstiges zur KG 440',
              description: 'Frequenzumformer',
            },
          ],
        },
        {
          number: '450',
          label:
            'Kommunikations-, sicherheits- und informationstechnische Anlagen',
          description:
            'Die einzelnen Anlagen enthalten die zugehörigen Verteiler, Kabel, Leitungen sowie die Brandschutzdurchführungen.',
          phases: [
            {
              number: '451',
              label: 'Telekommunikationsanlagen',
              description:
                'Einrichtungen zur Datenübertragung (Sprache, Text und Bild), soweit nicht in der KG 630 erfasst',
            },
            {
              number: '452',
              label: 'Such- und Signalanlagen',
              description:
                'Personenrufanlagen, Lichtruf- und Klingelanlagen, Türsprech- und Türöffneranlagen',
            },
            {
              number: '453',
              label: 'Zeitdienstanlagen',
              description: 'Uhren- und Zeiterfassungsanlagen',
            },
            {
              number: '454',
              label: 'Elektroakustische Anlagen',
              description:
                'Beschallungsanlagen, Konferenz- und Dolmetscheranlagen, Gegen- und Wechselsprechanlagen',
            },
            {
              number: '455',
              label: 'Audiovisuelle Medien- und Antennenanlagen',
              description:
                'AV-Medienanlagen, soweit nicht in anderen Kostengruppen erfasst, einschließlich der Sende- und Empfangsantennenanlagen und der Umsetzer',
            },
            {
              number: '456',
              label: 'Gefahrenmelde- und Alarmanlagen',
              description:
                'Brand-, Überfall-, Einbruchmeldeanlagen, Wächterkontrollanlagen, Zugangskontrollanlagen, Überwachungsanlagen im privaten und öffentlichen Raum',
            },
            {
              number: '457',
              label: 'Datenübertragungsnetze',
              description:
                'Netze zur Datenübertragung (Sprache, Text und Bild), soweit nicht in anderen Kostengruppen erfasst, Verlegesysteme, soweit nicht in der KG 444 erfasst',
            },
            {
              number: '458',
              label: 'Verkehrsbeeinflussungsanlagen',
              description:
                'Verkehrssignalanlagen, elektronische Anzeigetafeln, Mautsysteme, Parkleitsysteme, Verkehrstelematik (Soweit erforderlich kann die Verkehrstelematik entsprechend der KG 480 weiter untergliedert werden.)',
            },
            {
              number: '459',
              label: 'Sonstiges zur KG 450',
              description: 'Fernwirkanlagen',
            },
          ],
        },
        {
          number: '460',
          label: 'Förderanlagen',
          description: '',
          phases: [
            {
              number: '461',
              label: 'Aufzugsanlagen',
              description: 'Personenaufzüge, Lastenaufzüge',
            },
            {
              number: '462',
              label: 'Fahrtreppen, Fahrsteige',
              description: '',
            },
            {
              number: '463',
              label: 'Befahranlagen',
              description: 'Fassadenaufzüge und andere Befahranlagen',
            },
            {
              number: '464',
              label: 'Transportanlagen',
              description:
                'Automatische Warentransportanlagen, Aktentransportanlagen, Rohrpostanlagen',
            },
            {
              number: '465',
              label: 'Krananlagen',
              description: 'Krananlagen einschließlich Hebezeugen',
            },
            {
              number: '466',
              label: 'Hydraulikanlagen',
              description:
                'Hydraulikanlagen einschließlich hydraulischer Antriebe für mechanische Baukonstruktionen (z. B. für Toranlagen, Brücken, Ausleger, Entnahmeanlagen an Talsperren) sowie im Stahlwasserbau (z. B. für Schleusentore, Docktore, Wehrverschlüsse), soweit nicht in den KG 461 bis 465 und 469 erfasst',
            },
            {
              number: '469',
              label: 'Sonstiges zur KG 460',
              description: 'Hebebühnen, Parksysteme',
            },
          ],
        },
        {
          number: '470',
          label: 'Nutzungsspezifische und verfahrenstechnische Anlagen',
          description:
            'Mit dem Bauwerk fest verbundene Anlagen, die der besonderen Zweckbestimmung dienen, jedoch ohne die baukonstruktiven Einbauten (KG 380) Für die Abgrenzung gegenüber der KG 600 ist maßgebend, dass die nutzungsspezifischen Anlagen durch ihre Beschaffenheit und die Art ihres Einbaus technische und planerische Maßnahmen erforderlich machen (z. B. Anfertigen von Ausführungszeichnungen, Berechnungen, Anschließen von anderen technischen Anlagen).',
          phases: [
            {
              number: '471',
              label: 'Küchentechnische Anlagen',
              description:
                'Küchentechnische Anlagen zur Zubereitung, Ausgabe und Lagerung von Speisen und Getränken einschließlich zugehöriger Kälteanlagen',
            },
            {
              number: '472',
              label: 'Wäscherei-, Reinigungs- und badetechnische Anlagen',
              description:
                'Wäscherei- und Reinigungsanlagen einschließlich zugehöriger Wasseraufbereitung, Desinfektions- und Sterilisationseinrichtungen; Aufbereitungsanlagen für Schwimmbeckenwasser, soweit nicht in der KG 410 erfasst',
            },
            {
              number: '473',
              label:
                'Medienversorgungsanlagen, Medizin- und labortechnische Anlagen',
              description:
                'Zentralen für technische und medizinische Gase, Drucklufterzeugung, Vakuumerzeugung, Flüssigchemikalien, Lösungsmittel und vollentsalztes Wasser; Leitungen, Armaturen und Übergabestationen für technische und medizinische Gase, Druckluft, Vakuum, Flüssigchemikalien, Lösungsmittel und vollentsalztes Wasser; Diagnosegeräte, Behandlungsgeräte, OP-Einrichtungen und Hilfseinrichtungen für Menschen mit Behinderungen; Abzüge und Spülen; Wand- und Doppelarbeitstische; Medienzellen',
            },
            {
              number: '474',
              label: 'Feuerlöschanlagen',
              description:
                'Sprinkler- und Gaslöschanlagen, Löschwasserleitungen, Wandhydranten, Handfeuerlöscher',
            },
            {
              number: '475',
              label: 'Prozesswärme-, kälte- und -luftanlagen',
              description:
                'Wärme-, Kälte- und Kühlwasserversorgungsanlagen (z. B. für Produktion-, Forschung und Sportanlagen), soweit nicht in anderen Kostengruppen erfasst; Farbnebelabscheideanlagen, Prozessfortluftsysteme, Absauganlagen',
            },
            {
              number: '476',
              label: 'Weitere nutzungsspezifische Anlagen',
              description:
                'Abfall- und Medienentsorgungsanlagen, Staubsauganlagen, Bühnentechnische Anlagen, Tankstellen- und Waschanlagen, Taumittelsprüh- und Enteisungsanlagen',
            },
            {
              number: '477',
              label: 'Verfahrenstechnische Anlagen, Wasser, Abwasser und Gase',
              description:
                'Verfahrenstechnische Anlagen für Wassergewinnung, Abwasserbehandlung und -entsorgung (z. B. Anlagen der Wassergewinnung, Wasseraufbereitungsanlagen, Abwassereinigungsanlagen, Schlammbehandlungsanlagen, Regenwasserbehandlungsanlagen, Grundwasserdekontaminierungsanlagen), Anlagen für die Ver- und Entsorgung mit Gasen (z. B. Odorieranlagen)',
            },
            {
              number: '478',
              label:
                'Verfahrenstechnische Anlagen, Feststoffe, Wertstoffe und Abfälle',
              description:
                'Anlagen für die Ver- und Entsorgung mit Feststoffen; Anlagen der Abfallentsorgung (z. B. für Kompostwerke, Mülldeponien, Verbrennungsanlagen, Pyrolyseanlagen, mehrfunktionale Aufbereitungsanlagen für Wertstoffe)',
            },
            {
              number: '479',
              label: 'Sonstiges zur KG 470',
              description:
                'Entnahmeanlagen an Talsperren (hinsichtlich Wassermenge und Wassergüte) einschließlich der Entnahmeleitungen, der Antriebe und aller Anlagenteile (z. B. Armaturen, Formstücke, Pass- und Ausbaustücke, Sonderbauteile); Messtechnische Überwachungsanlagen an Stauanlagen (z. B. Pegel, geodätische Messpunkte, mobile Messgeräte, Lote, Thermometer, Sickerwasser-, Grundwasser- und Sohlwasserdruckmesseinrichtungen) einschließlich Übertragungssystemen',
            },
          ],
        },
        {
          number: '480',
          label: 'Gebäude- und Anlagenautomation',
          description:
            'Überwachungs-, Steuer-, Regel- und Optimierungseinrichtungen zur automatischen Durchführung von technischen Funktionsabläufen',
          phases: [
            {
              number: '481',
              label: 'Automationseinrichtungen',
              description:
                'Automationsstationen, Bedien-, Anzeige- und Ausgabeeinrichtungen, Hard- und Software, Lizenzen, Funktionen, Schnittstellen, Feldgeräte, Programmiereinrichtungen',
            },
            {
              number: '482',
              label: 'Schaltschränke, Automationsschwerpunkte',
              description:
                'Schaltschränke zur Aufnahme von Automationseinrichtungen, Leistungs-, Steuerungs- und Sicherungsbaugruppen',
            },
            {
              number: '483',
              label: 'Automationsmanagement',
              description:
                'Übergeordnete Einrichtungen für Automation und Management, Bedien-, Anzeige- und Ausgabeeinrichtungen, Hard- und Software, Lizenzen, Funktionen, Schnittstellen',
            },
            {
              number: '484',
              label: 'Kabel, Leitungen und Verlegesysteme',
              description:
                'Kabel, Leitungen und Verlegesysteme, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '485',
              label: 'Datenübertragungsnetze',
              description:
                'Netze zur Datenübertragung, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '489',
              label: 'Sonstiges zur KG 480',
              description: '',
            },
          ],
        },
        {
          number: '490',
          label: 'Sonstige Maßnahmen für technische Anlagen',
          description:
            'Technische Anlagen und übergreifende Maßnahmen im Zusammenhang mit den technischen Anlagen, die nicht einzelnen Kostengruppen der KG 400 zugeordnet werden können oder die nicht in der KG 390 oder der KG 590 erfasst sind',
          phases: [
            {
              number: '491',
              label: 'Baustelleneinrichtung',
              description:
                'Einrichten, Vorhalten, Betreiben und Räumen der übergeordneten Baustelleneinrichtung für technische Anlagen ( z. B. Material- und Geräteschuppen, Lager-, Wasch-, Toiletten- und Aufenthaltsräume, Bauwagen, Misch- und Transportanlagen, Energie- und Bauwasseranschlüsse, Baustraßen, Lager- und Arbeitsplätze, Verkehrssicherungen, Abdeckungen, Bauschilder, Bau- und Schutzzäune, Baubeleuchtung, Baustrom, Bauwasser)',
            },
            {
              number: '492',
              label: 'Gerüste',
              description:
                'Auf-, Um-, und Abbauen sowie Vorhalten von Gerüsten',
            },
            {
              number: '493',
              label: 'Sicherungsmaßnahmen',
              description:
                'Sicherungsmaßnahmen an bestehenden Bauwerken (z. B. Unterfangungen, Abstützungen)',
            },
            {
              number: '494',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbruch- und Demontagearbeiten einschließlich Zwischenlagern wieder verwendbarer Teile, Abfuhr des Abbruchmaterials, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '495',
              label: 'Instandsetzungen',
              description:
                'Maßnahmen zur Wiederherstellung des zum bestimmungsgemäßen Gebrauch geeigneten Zustandes, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '496',
              label: 'Materialentsorgung',
              description:
                'Entsorgung von Materialien und Stoffen, die bei dem Abbruch, bei der Demontage und bei dem Ausbau von Anlagenteilen oder bei der Erstellung einer Bauleistung anfallen zum Zweck des Recyclings oder der Deponierung',
            },
            {
              number: '497',
              label: 'Zusätzliche Maßnahmen',
              description:
                'Zusätzliche Maßnahmen bei der Erstellung von technischen Anlagen (z. B. Schutz von Personen und Sachen sowie betriebliche Sicherungsmaßnahmen beim Bauen unter Betrieb); Reinigung vor der Inbetriebnahme; Maßnahmen aufgrund von Forderungen des Wasser-, Landschafts-, Lärm- und Erschütterungsschutzes während der Bauzeit; Schlechtwetter und Winterbauschutz, Erwärmung der technischen Anlagen, Schneeräumung',
            },
            {
              number: '498',
              label: 'Provisorische technische Anlagen',
              description:
                'Erstellung, Betrieb und Beseitigung provisorischer technischer Anlagen, Anpassung der technischen Anlagen bis zur Inbetriebnahme der endgültigen technischen Anlagen',
            },

            {
              number: '499',
              label: 'Sonstiges zur KG 490',
              description:
                'Technische Anlagen und Maßnahmen, die mehrere Kostengruppen betreffen; Baustellengemeinkosten',
            },
          ],
        },
      ],
    },

    {
      number: '500',
      label: 'Außenanlagen und Freiflächen',
      description:
        'Bauleistungen und Lieferungen zur Herstellung von Außenanlagen der Bauwerke sowie von Freiflächen, die selbstständig und unabhängig der Bauwerke sind, mit den dazugehörigen baulichen Anlagen, Baukonstruktionen oder technischen Anlagen Dazu gehören auch die mit baulichen Anlagen fest verbundenen Einbauten, die der besonderen Zweckbestimmung dienen sowie übergreifende Maßnahmen. Die Kosten von Außenanlagen und Freiflächen, die unterbaut sind (z. B von Tiefgaragen, Untergeschossen, Tunneln), sind bei den betreffenden Kostengruppen auszuweisen. Bei Umbauten und Modernisierungen von Außenanlagen und Freiflächen zählen hierzu auch die Kosten von Teilabbruch-, Instandsetzungs-, Sicherungs- und Demontagearbeiten. Die Kosten sind bei den betreffenden Kostengruppen auszuweisen. Außerhalb des Grundstücks liegende Anlagen des Verkehrs und technische Anlagen zur Erschließung des Grundstücks gehören zur KG 200. Die mit dem Bauwerk verbundenen Fassaden-, Wand-, Dach- und Innenraumbegrünungen sowie landschaftsgestalterische Einbauten gehören zur KG 300. Eigenständige Bauwerke von Infrastrukturanlagen gehören zur KG 300 und KG 400.',
      phases: [
        {
          number: '510',
          label: 'Erdbau',
          description:
            'Oberbodenarbeiten und Bodenarbeiten, Erdbaumaßnahmen, Baugruben, Dämme, Einschnitte, Wälle, Hangsicherungen',
          phases: [
            {
              number: '511',
              label: 'Herstellung',
              description:
                'Bodenabtrag und Bodensicherung einschließlich Oberboden sowie Bodenauftrag; Aushub von Baugruben und Baugräben einschließlich der Arbeitsräume und Böschungen; Lagern, Bodenlieferung und Bodenabfuhr; Verfüllungen und Hinterfüllungen; Planum, Mulden, Bankette',
            },
            {
              number: '512',
              label: 'Umschließung',
              description:
                'Verbau und Sicherung von Baugruben, Baugräben, Dämmen, Wällen und Einschnitten (z. B. Schlitz-, Pfahl-, Spund-, Trägerbohl-, Injektions- und Spritzbetonsicherung) einschließlich der Verankerungen, Absteifungen und Böschungen',
            },
            {
              number: '513',
              label: 'Wasserhaltung',
              description:
                'Beseitigung des Grund- und Schichtenwassers während der Bauzeit',
            },
            {
              number: '514',
              label: 'Vortrieb',
              description:
                'Erdausbruch unter Tage einschließlich Stützung und Sicherung',
            },
            {
              number: '519',
              label: 'Sonstiges zur KG 510',
              description: '',
            },
          ],
        },
        {
          number: '520',
          label: 'Gründung, Unterbau',
          description:
            'Gründungs- und Unterbaumaßnahmen von Außenanlagen und Freiflächen einschließlich der zugehörigen Erdarbeiten und Sauberkeitsschichten, soweit nicht in der KG 510 erfasst',
          phases: [
            {
              number: '521',
              label: 'Baugrundverbesserung',
              description:
                'Bodenaustausch, Verdichtung, Einpressung, Ankerung, Stützmaßnahmen, Bodenlockerung, Verlegung von Geotextilien',
            },
            {
              number: '522',
              label: 'Gründungen und Bodenplatten',
              description:
                'Einzelfundamente, Streifenfundamente, Fundament-, Sohl- und Bodenplatten',
            },
            {
              number: '523',
              label: 'Gründungsbeläge',
              description:
                'Beläge auf Sohl-, Boden- und Fundamentplatten (z. B. Estriche, Dichtungs-, Dämm-, Schutz- und Nutzschichten)',
            },
            {
              number: '524',
              label: 'Abdichtungen und Bekleidungen',
              description:
                'Konstruktionsschichten unterhalb der Sohl-, Boden- und Fundamentplatte, Abdichtungen und Bekleidungen der Gründung einschließlich Dämmungen sowie Filter-, Trenn-, Sauberkeits- und Schutzschichten',
            },
            {
              number: '525',
              label: 'Dränagen',
              description:
                'Leitungen, Schächte, Packungen, Pumpensümpfe, Tiefenentwässerung, Oberflächenentwässerung',
            },
            {
              number: '529',
              label: 'Sonstiges zur KG 520',
              description: '',
            },
          ],
        },
        {
          number: '530',
          label: 'Oberbau, Deckschichten',
          description:
            'Oberbau-und Deckschichten von Außenanlagen und Freiflächen; Oberbau und Deckschichten mit oder ohne Bindemittel von befestigten Flächen einschließlich Bettungsmaterialien, Fugenfüllungen, Markierungen und Einfassungen (z. B. Borde, Kantensteine)',
          phases: [
            {
              number: '531',
              label: 'Wege',
              description:
                'Oberbau und Deckschichten von Flächen für den Fuß- und Radverkehr',
            },
            {
              number: '532',
              label: 'Straßen',
              description:
                'Oberbau- und Deckschichten von Flächen für den Leicht- und Schwerverkehr sowie für Fußgängerzonen mit Anlieferungsverkehr',
            },
            {
              number: '533',
              label: 'Plätze, Höfe, Terrassen',
              description:
                'Oberbau- und Deckschichten von Platzflächen, Innenhöfen, Terrassen und Sitzplätzen',
            },
            {
              number: '534',
              label: 'Stellplätze',
              description:
                'Oberbau- und Deckschichten von Flächen für den ruhenden Verkehr',
            },
            {
              number: '535',
              label: 'Sportplatzflächen',
              description: 'Oberbau- und Deckschichten von Sportplatzflächen',
            },
            {
              number: '536',
              label: 'Spielplatzflächen',
              description: 'Oberbau- und Deckschichten von Spielplatzflächen',
            },
            {
              number: '537',
              label: 'Gleisanlagen',
              description:
                'Gleise, Weichen und Gleisabschlüsse einschließlich Schwellen',
            },
            {
              number: '538',
              label: 'Flugplatzflächen',
              description:
                'Oberbau und Deckschichten beispielsweise von Hubschrauberlandeplätzen',
            },
            {
              number: '539',
              label: 'Sonstiges zur KG 530',
              description: '',
            },
          ],
        },
        {
          number: '540',
          label: 'Baukonstruktionen',
          description:
            'Baukonstruktionen in Außenanlagen und Freiflächen, die eigenständig und unabhängig von Bauwerken sind Die Bodenarbeiten und Erdbaumaßnahmen gehören zur KG 510, die Gründungs- und Unterbaumaßnahmen zur KG 520. Baukonstruktionen, die eigenständige Bauwerke darstellen, werden in der KG 300 erfasst.',
          phases: [
            {
              number: '541',
              label: 'Einfriedungen',
              description:
                'Zäune, Mauern, Türen, Tore, Schutzgitter, Schrankenanlagen',
            },
            {
              number: '542',
              label: 'Schutzkonstruktionen',
              description:
                'Lärmschutzwände, Sichtschutzwände, Schutzgitter; Konstruktionen für beispielsweise Sonnenschutz einschließlich Antrieben',
            },
            {
              number: '543',
              label: 'Wandkonstruktionen',
              description:
                'Stütz- und Schwergewichtsmauern, elementierte Konstruktionen einschließlich Bekleidungen, füllender Teile und Abdichtungen',
            },
            {
              number: '544',
              label: 'Rampen, Treppen, Tribünen',
              description:
                'Rampen, Treppen und Tribünen einschließlich Geländern, Handläufen und Absturzsicherungen',
            },
            {
              number: '545',
              label: 'Überdachungen',
              description:
                'Überdachungen, Unterstände, Wetterschutzkonstruktionen und Pergolen einschließlich deren Stützkonstruktionen',
            },
            {
              number: '546',
              label: 'Stege',
              description:
                'Stege und kleinere Brücken für den Fuß- und Radverkehr sowie Bootsstege einschließlich Rampen, Stufen, Treppen, Geländern, Handläufen, Absturzsicherungen und Wetterschutz',
            },
            {
              number: '547',
              label: 'Kanal- und Schachtkonstruktionen',
              description:
                'Rohrkanäle und -schächte, Leerrohre für technische Anlagen',
            },
            {
              number: '548',
              label: 'Wasserbecken',
              description: 'Wasserbecken, Schwimmbecken, Schwimmteiche',
            },
            {
              number: '549',
              label: 'Sonstiges zur KG 540',
              description: '',
            },
          ],
        },
        {
          number: '550',
          label: 'Technische Anlagen',
          description:
            'Technische Anlagen in Außenanlagen einschließlich der Ver- und Entsorgung des Bauwerks sowie in Freiflächen, die eigenständig und unabhängig von Bauwerken sind Die Bodenarbeiten und Erdbaumaßnahmen gehören zur KG 510, die Gründungs- und Unterbaumaßnahmen zur KG 520.',
          phases: [
            {
              number: '551',
              label: 'Abwasseranlagen',
              description:
                'Abwasserleitungen, häusliche Kläranlagen, Oberflächen- und Bauwerksentwässerungsanlagen, Sammelgruben, Abscheider, Hebeanlagen',
            },
            {
              number: '552',
              label: 'Wasseranlagen',
              description:
                'Brunnenanlagen, Zisternen, Druckerhöhungsanlagen, Wasserversorgungsleitungen, Löschwasseranlagen, Beregnungsanlagen',
            },
            {
              number: '553',
              label: 'Anlagen für Gase und Flüssigkeiten',
              description:
                'Leitungen für Gase und wassergefährdende Flüssigkeiten, Flüssiggasanlagen',
            },
            {
              number: '554',
              label: 'Wärmeversorgungsanlagen',
              description:
                'Wärmeerzeugungsanlagen, Wärmeversorgungsleitungen, Freiflächen- und Rampenheizungen',
            },
            {
              number: '555',
              label: 'Raumlufttechnische Anlagen',
              description:
                'Anlagenteile der Raumlufttechnik (z. B. Außenluftansaugung, Fortluftausblas, Erdwärmetauscher, Kälteversorgung)',
            },
            {
              number: '556',
              label: 'Elektrische Anlagen',
              description:
                'Elektrische Anlagen für Starkstrom (z. B. für Stromversorgungsleitungen, Freilufttrafostationen, Eigenstromerzeugungsanlagen); Außenbeleuchtungsanlagen, Beleuchtungsanlagen für Wege, Straßen, Plätze und Flächen für den ruhenden Verkehr sowie Flutlichtanlagen und Fahrleitungsanlagen einschließlich der Maste und Befestigungen',
            },
            {
              number: '557',
              label:
                'Kommunikations-, sicherheits- und informationstechnische Anlagen, Automation',
              description:
                'Leitungsnetze, Beschallungsanlagen, Zeitdienstanlagen und Verkehrssignalanlagen, elektronische Anzeigetafeln, Objektsicherungsanlagen, Parkleitsysteme',
            },
            {
              number: '558',
              label: 'Nutzungsspezifische Anlagen',
              description:
                'Medienversorgungsanlagen, Tankanlagen, badetechnische Anlagen',
            },
            {
              number: '559',
              label: 'Sonstiges zur KG 550',
              description: '',
            },
          ],
        },
        {
          number: '560',
          label: 'Einbauten in Außenanlagen und Freiflächen',
          description:
            'Einbauten in Außenanlagen und Freiflächen, die eigenständig und unabhängig von Bauwerken sind Die Erdbaumaßnahmen gehören zur KG 510, die Gründungs- und Unterbaumaßnahmen zur KG 520.',
          phases: [
            {
              number: '561',
              label: 'Allgemeine Einbauten',
              description:
                'Wirtschaftsgegenstände (z. B. Sitzmöbel, Fahrradständer, Pflanzbehälter, Abfallbehälter, Fahnenmaste, Absperrpoller, Stoßabweiser)',
            },
            {
              number: '562',
              label: 'Besondere Einbauten',
              description:
                'Einbauten in Spielplätzen (z. B. Spielgeräte und Klettereinrichtungen); Einbauten für Sportanlagen, Freizeitanlagen und Tiergehege',
            },

            {
              number: '563',
              label: 'Orientierungs- und Informationssysteme',
              description:
                'Einbauten, die der Orientierung und Information dienen (z. B. für Flucht, Rettung, Orientierung, Werbung)',
            },
            { number: '569', label: 'Sonstiges zur KG 560', description: '' },
          ],
        },
        {
          number: '570',
          label: 'Vegetationsflächen',
          description: 'Die Erdbaumaßnahmen gehören zur KG 510.',
          phases: [
            {
              number: '571',
              label: 'Vegetationstechnische Bodenbearbeitung',
              description:
                'Vorbereitung von Pflanzflächen durch Oberbodenauftrag, Oberbodenlockerung, Fräsen, Planieren; Bodenverbesserung (z. B. Düngung, Bodenhilfsstoffe und Zwischenbegrünungen)',
            },
            {
              number: '572',
              label: 'Sicherungsbauweisen',
              description:
                'Vegetationsstücke, Geotextilien, Flechtwerk, Böschungssicherungen, Flächensicherungen',
            },
            {
              number: '573',
              label: 'Pflanzflächen',
              description:
                'Pflanzung von Gehölzen und Stauden einschließlich Feinplanum und Fertigstellungspflege',
            },
            {
              number: '574',
              label: 'Rasen- und Saatflächen',
              description:
                'Aussaat von Saatgut und Rasen sowie Verlegung von Fertigrasen einschließlich Feinplanum und Fertigstellungspflege',
            },
            {
              number: '579',
              label: 'Sonstiges zur KG 570',
              description:
                'Entwicklungspflege von Pflanz-, Rasen- und Saatflächen',
            },
          ],
        },
        {
          number: '580',
          label: 'Wasserflächen',
          description:
            'Naturnahe Wasserflächen, Bäche, Teiche und Seen einschließlich Sohl- und Uferausbildung sowie Uferbefestigung Die Erdbaumaßnahmen gehören zur KG 510.',
          phases: [
            {
              number: '581',
              label: 'Befestigungen',
              description:
                'Tragschichten einschließlich Bodensubstraten, Kies- und Schotterschichten sowie Wasserbausteinbettungsschichten, soweit nicht unter anderen Kostengruppen erfasst',
            },
            {
              number: '582',
              label: 'Abdichtungen',
              description:
                'Planum, Planumsschutzschichten, Frostschutzschichten, Bewehrungs-, Trenn-, Filter- und Dichtungsschichten; Schutzschichten',
            },
            {
              number: '583',
              label: 'Bepflanzungen',
              description:
                'Unterwasser- und Wasserpflanzen, Röhrichte, Bepflanzungen der Wasserwechselzonen',
            },
            {
              number: '589',
              label: 'Sonstiges zur KG 580',
              description: 'Entwicklungspflege von Bepflanzungen',
            },
          ],
        },
        {
          number: '590',
          label: 'Sonstige Maßnahmen für Außenanlagen und Freiflächen',
          description:
            'Anlagen und übergreifende Maßnahmen im Zusammenhang mit den Außenanlagen und Freiflächen, die nicht einzelnen Kostengruppen der KG 500 zugeordnet werden können oder die nicht in der KG 390 oder der KG 490 erfasst sind',
          phases: [
            {
              number: '591',
              label: 'Baustelleneinrichtung',
              description:
                'Einrichten, Vorhalten, Betreiben und Räumen der übergeordneten Baustelleneinrichtung für Außenanlagen und Freiflächen (z. B. Material- und Geräteschuppen, Lager-, Wasch-, Toiletten- und Aufenthaltsräume, Bauwagen, Misch- und Transportanlagen, Energieund Bauwasseranschlüsse, Baustraßen, Lager- und Arbeitsplätze, Verkehrssicherungen, Abdeckungen, Bauschilder, Bau- und Schutzzäune, Baubeleuchtung, Baustrom, Bauwasser)',
            },
            {
              number: '592',
              label: 'Gerüste',
              description:
                'Auf-, Um-, und Abbauen sowie Vorhalten von Gerüsten',
            },
            {
              number: '593',
              label: 'Sicherungsmaßnahmen',
              description:
                'Sicherungsmaßnahmen an bestehenden baulichen Anlagen (z. B. Unterfangungen, Abstützungen)',
            },
            {
              number: '594',
              label: 'Abbruchmaßnahmen',
              description:
                'Abbruch- und Demontagearbeiten einschließlich Zwischenlagern wiederverwendbarer Teile, Abfuhr des Abbruchmaterials, soweit nicht in anderen Kostengruppen erfasst',
            },

            {
              number: '595',
              label: 'Instandsetzungen',
              description:
                'Maßnahmen zur Wiederherstellung des zum bestimmungsgemäßen Gebrauch geeigneten Zustandes, soweit nicht in anderen Kostengruppen erfasst',
            },
            {
              number: '596',
              label: 'Materialentsorgung',
              description:
                'Entsorgung von Materialien und Stoffen, die bei dem Abbruch, bei der Demontage und bei dem Ausbau von Außenanlagen und Freiflächen oder bei der Erstellung einer Bauleistung anfallen zum Zweck des Recyclings oder der Deponierung',
            },
            {
              number: '597',
              label: 'Zusätzliche Maßnahmen',
              description:
                'Zusätzliche Maßnahmen bei der Erstellung von Außenanlagen und Freiflächen (z. B. Schutz von Personen und Sachen sowie betriebliche Sicherungsmaßnahmen beim Bauen unter Betrieb); Reinigung vor Inbetriebnahme; Maßnahmen aufgrund von Forderungen des Wasser-, Landschafts-, Lärm- und Erschütterungsschutzes während der Bauzeit; Schlechtwetter und Winterbauschutz, Erwärmung, Schneeräumung',
            },
            {
              number: '598',
              label: 'Provisorische Außenanlagen und Freiflächen',
              description:
                'Erstellung, Betrieb und Beseitigung provisorischer Außenanlagen und Freiflächen, Anpassung der Außenanlagen und Freiflächen bis zur Inbetriebnahme der endgültigen Außenanlagen und Freiflächen',
            },
            {
              number: '599',
              label: 'Sonstiges zur KG 590',
              description:
                'Anlagen und Maßnahmen, die mehrere Kostengruppen betreffen; Baustellengemeinkosten',
            },
          ],
        },
      ],
    },

    {
      number: '600',
      label: 'Ausstattung und Kunstwerke',
      description:
        'Bewegliche oder ohne besondere Maßnahmen zu befestigende Sachen, die zur Ingebrauchnahme, zur allgemeinen Benutzung oder zur künstlerischen Gestaltung des Bauwerks sowie der Außenanlagen und Freiflächen dienen (siehe Anmerkungen zu den KG 380 und 470)',
      phases: [
        {
          number: '610',
          label: 'Allgemeine Ausstattung',
          description:
            'Möbel und Geräte (z. B. Sitz- und Liegemöbel, Schränke, Regale, Tische); Textilien (z. B. Vorhänge, Wandbehänge, lose Teppiche, Wäsche); Hauswirtschafts-, Garten- und Reinigungsgeräte',
        },
        {
          number: '620',
          label: 'Besondere Ausstattung',
          description:
            'Ausstattungsgegenstände, die der besonderen Zweckbestimmung eines Objekts dienen (z. B. wissenschaftliche , medizinische, technische Geräte)',
        },
        {
          number: '630',
          label: 'Informationstechnische Ausstattung',
          description:
            'DV-Geräte (z. B. Server, PC sowie periphere Geräte und Zubehör)',
        },
        {
          number: '640',
          label: 'Künstlerische Ausstattung',
          description:
            'Künstlerische Ausstattung oder Gestaltung des Bauwerks sowie der Außenanlagen und Freiflächen',
          phases: [
            {
              number: '641',
              label: 'Kunstobjekte',
              description:
                'Kunstwerke (z. B. Skulpturen, Objekte, Gemälde, Möbel, Antiquitäten, Altäre, Taufbecken)',
            },
            {
              number: '642',
              label: 'Künstlerische Gestaltung des Bauwerks',
              description:
                'Künstlerisch gestaltete Teile des Bauwerks (z. B. Malereien, Reliefs, Mosaiken, künstlerische Glas-, Schmiede-, Steinmetzarbeiten)',
            },
            {
              number: '643',
              label:
                'Künstlerische Gestaltung der Außenanlagen und Freiflächen',
              description:
                'Künstlerisch gestaltete Teile der Außenanlagen und Freiflächen (z. B. Malereien, Reliefs, Mosaiken, künstlerische Glas-, Schmiede-, Steinmetzarbeiten)',
            },
            {
              number: '649',
              label: 'Sonstiges zur KG 640',
              description: '',
            },
          ],
        },
        {
          number: '690',
          label: 'Sonstige Ausstattung',
          description: 'Schilder, Wegweiser, Informations- und Werbetafeln',
        },
      ],
    },

    {
      number: '700',
      label: 'Baunebenkosten',
      description:
        'Leistungen, die neben den Bauleistungen und Lieferungen für das Bauprojekt erforderlich sind (z. B. Leistungen des Bauherren, Vorbereitung der Objektplanung, Leistungen der Objekt- und Fachplanung, künstlerische Leistungen und allgemeine Baunebenkosten)',
      phases: [
        {
          number: '710',
          label: 'Bauherrenaufgaben',
          description: 'Selbst wahrgenommene oder übertragene Aufgaben',
          phases: [
            {
              number: '711',
              label: 'Projektleitung',
              description:
                'Zielvorgaben, Überwachung und Vertretung der Bauherreninteressen',
            },
            {
              number: '712',
              label: 'Bedarfsplanung',
              description:
                'Bedarfs-, Betriebs- und Organisationsplanung beispielsweise zur betrieblichen Organisation, zur Arbeitsplatzgestaltung, zur Erstellung von Raum- und Funktionsprogrammen, zur betrieblichen Ablaufplanung und zur Inbetriebnahme des Objekts',
            },
            {
              number: '713',
              label: 'Projektsteuerung',
              description:
                'Projektsteuerungsleistungen sowie andere Leistungen, die sich mit der übergeordneten Steuerung und Kontrolle von Projektorganisation, Terminen, Kosten, Qualitäten und Quantitäten befassen',
            },
            {
              number: '714',
              label: 'Sicherheits- und Gesundheitsschutzkoordination',
              description:
                'Planungs- und Koordinationsleistungen für die Arbeitssicherheit und den Gesundheitsschutz auf der Baustelle',
            },
            {
              number: '715',
              label: 'Vergabeverfahren',
              description: 'Verhandlungsverfahren, wettbewerblicher Dialog',
            },
            {
              number: '719',
              label: 'Sonstiges zur KG 710',
              description:
                'Baubetreuung, Umweltbaubegleitung, Rechtsberatung, Steuerberatung, Streitbeilegung (außergerichtliche und gerichtliche), Nachhaltigkeitskoordinierung bzw. -auditierung, Management zur Inbetriebnahme des Objekts',
            },
          ],
        },
        {
          number: '720',
          label: 'Vorbereitung der Objektplanung',
          description: '',
          phases: [
            {
              number: '721',
              label: 'Untersuchungen',
              description:
                'Standortanalysen, Baugrundgutachten, Gutachten für die Verkehrsanbindung, Bestandsanalysen (z. B. Untersuchungen zum Gebäudebestand bei Umbau- und Modernisierungsmaßnahmen); Untersuchungen im Rahmen von artenschutzrechtlichen Prüfungen, floristische und faunistische Untersuchungen; Untersuchungen zu Altlasten, Kampfmitteln und kulturhistorischen Funden',
            },
            {
              number: '722',
              label: 'Wertermittlungen',
              description:
                'Gutachten zur Ermittlung von Gebäudewerten, soweit nicht in der KG 126 erfasst',
            },
            {
              number: '723',
              label: 'Städtebauliche Leistungen',
              description:
                'Bauleitplanung einschließlich Umweltbericht und städtebaulicher Entwurf, städtebauliche Rahmenpläne',
            },
            {
              number: '724',
              label: ' Landschaftsplanerische Leistungen',
              description:
                'Landschaftsplan, Grünordnungsplan, Biotopvernetzungsplanungen, Umweltprüfung, Umweltverträglichkeitsstudie, landschaftspflegerische Begleitplanung, Eingriffs- und Ausgleichsplanung',
            },
            {
              number: '725',
              label: 'Wettbewerbe',
              description:
                'Durchführung von Ideenwettbewerben und Realisierungswettbewerben',
            },
            {
              number: '729',
              label: 'Sonstiges zur KG 720',
              description: '',
            },
          ],
        },
        {
          number: '730',
          label: 'Objektplanung',
          description: 'Planung und Überwachung der Ausführung',
          phases: [
            {
              number: '731',
              label: 'Gebäude und Innenräume',
              description: '',
            },
            { number: '732', label: 'Freianlagen', description: '' },
            { number: '733', label: 'Ingenieurbauwerke', description: '' },
            { number: '734', label: 'Verkehrsanlagen', description: '' },
            {
              number: '739',
              label: 'Sonstiges zur KG 730',
              description: '',
            },
          ],
        },
        {
          number: '740',
          label: 'Fachplanung',
          description: 'Planung und Überwachung der Ausführung',
          phases: [
            { number: '741', label: 'Tragwerksplanung', description: '' },
            { number: '742', label: 'Technische Ausrüstung', description: '' },
            { number: '743', label: 'Bauphysik', description: '' },
            {
              number: '744',
              label: 'Geotechnik',
              description: '',
            },
            {
              number: '745',
              label: 'Ingenieurvermessung',
              description:
                'Planungs- und baubezogene vermessungstechnische Leistungen; die grundstücksbezogenen Leistungen für die Grenzvermessung sowie für die Übernahme in das Liegenschaftskataster gehören zur KG 121.',
            },
            {
              number: '746',
              label: 'Lichttechnik, Tageslichttechnik',
              description: '',
            },
            { number: '747', label: 'Brandschutz', description: '' },
            {
              number: '748',
              label: 'Altlasten, Kampfmittel, kulturhistorische Funde',
              description:
                'Planungen für Altlastenbeseitigung, Kampfmittelräumung und die Sicherung kulturhistorischer Funde',
            },
            {
              number: '749',
              label: 'Sonstiges zur KG 740',
              description: 'Fassadenplanung, Geothermie',
            },
          ],
        },
        {
          number: '750 ',
          label: 'Künstlerische Leistungen',
          description: '',
          phases: [
            {
              number: '751',
              label: 'Kunstwettbewerbe',
              description:
                'Durchführung von Wettbewerben zur Erarbeitung eines Konzepts für Kunstwerke oder künstlerisch gestaltete Bauteile',
            },
            {
              number: '752',
              label: 'Honorare',
              description:
                'Geistig-schöpferische Leistungen für Kunstwerke oder künstlerisch gestaltete Bauteile, soweit nicht in der KG 640 erfasst',
            },
            { number: '759', label: 'Sonstiges zur KG 750', description: '' },
          ],
        },
        {
          number: '760',
          label: 'Allgemeine Baunebenkosten',
          description: '',
          phases: [
            { number: '761', label: 'Gutachten und Beratung', description: '' },
            {
              number: '762',
              label: 'Prüfungen, Genehmigungen, Abnahmen',
              description:
                'Prüfungen, Genehmigungen und Abnahmen (z. B. Prüfung der Tragwerksplanung, Konformitätsprüfungen von Nachhaltigkeitsauditierungen)',
            },
            {
              number: '763',
              label: 'Bewirtschaftungskosten',
              description:
                'Baustellenbewachung, Nutzungsentschädigungen während der Bauzeit; Gestellung des Baustellenbüros für Planer und Bauherrn sowie dessen Beheizung, Beleuchtung und Reinigung',
            },
            {
              number: '764',
              label: 'Bemusterungskosten',
              description:
                'Modellversuche, Musterstücke, Eignungsversuche, Eignungsmessungen',
            },
            {
              number: '765',
              label: 'Betriebskosten nach der Abnahme',
              description:
                'Kosten für den vorläufigen Betrieb insbesondere der technischen Anlagen nach der Abnahme bis zur Inbetriebnahme',
            },
            {
              number: '766',
              label: 'Versicherungen',
              description:
                'Bauherrenhaftpflichtversicherung, Bauwesenversicherung',
            },
            {
              number: '769',
              label: 'Sonstiges zur KG 760',
              description:
                'Vervielfältigung und Dokumentation, Versand- und Kommunikationskosten, Veranstaltungen (z. B. Grundsteinlegung, Richtfest)',
            },
          ],
        },
        {
          number: '790',
          label: 'Sonstige Baunebenkosten',
          description: '',
          phases: [
            {
              number: '791',
              label: 'Bestandsdokumentation',
              description:
                'Liegenschafts- und Gebäudebestandsdokumentation als Grundlage für die Nutzung (z. B. Vermessung, Fachdatenerhebung)',
            },
            {
              number: '799',
              label: 'Sonstiges zur KG 790',
              description: '',
            },
          ],
        },
      ],
    },

    {
      number: '800',
      label: 'Finanzierung',
      description:
        'Kosten, die im Zusammenhang mit der Finanzierung des Bauprojekts bis zum Beginn der Nutzung anfallen',
      phases: [
        {
          number: '810',
          label: 'Finanzierungsnebenkosten',
          description:
            'Kosten für die Finanzierungsplanung und die Beschaffung von Finanzierungsmitteln, Gerichts- und Notargebühren für die mit der Finanzierung verbundenen Eintragungen und Löschungen im Grundbuch',
        },
        {
          number: '820',
          label: 'Fremdkapitalzinsen',
          description:
            'Zinsen für das zur Finanzierung beschaffte Fremdkapital bis zum Beginn der Nutzung',
        },
        {
          number: '830',
          label: 'Eigenkapitalzinsen',
          description:
            'Kalkulatorische Zinsen für das zur Finanzierung eingesetzte Eigenkapital bis zum Beginn der Nutzung',
        },
        {
          number: '840',
          label: 'Bürgschaften',
          description: 'Gebühren für Zahlungsbürgschaften',
        },
        {
          number: '890',
          label: 'Sonstige Finanzierungskosten',
          description: '',
        },
      ],
    },
  ],
};
